import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Play, Gamepad2 } from 'lucide-react';
import './App.css';

function NeonGravityRunner() {
    const navigate = useNavigate();

    const handlePlay = () => {
        window.open('/game.html', '_blank', 'noopener,noreferrer');
    };

    return (
        <div className="game-page">
            <div className="game-page-inner">
                <button className="games-back-btn" onClick={() => navigate('/games')}>
                    <ArrowLeft size={18} /> Back to Games
                </button>

                <div className="game-page-hero">
                    <div className="game-page-glow" />
                    <Gamepad2 className="game-page-icon" />
                    <h1>Neon Gravity Runner</h1>
                    <p className="game-page-tagline">Flip gravity. Dodge everything. Don't die.</p>
                </div>

                <div className="game-page-info">
                    <div className="game-info-card">
                        <h4>How to Play</h4>
                        <ul>
                            <li><kbd>Space</kbd> / <kbd>Click</kbd> / <kbd>Tap</kbd> — Flip gravity</li>
                            <li><kbd>Esc</kbd> — Pause</li>
                            <li><kbd>F</kbd> — Fullscreen</li>
                            <li>Collect green gems for bonus points</li>
                            <li>Difficulty increases as you survive longer</li>
                        </ul>
                    </div>
                    <div className="game-info-card">
                        <h4>Tips</h4>
                        <ul>
                            <li>Don't spam flip — time your gravity changes</li>
                            <li>Watch for moving obstacles (orange blocks)</li>
                            <li>Gems give +5 points each</li>
                            <li>Your high score is saved automatically</li>
                        </ul>
                    </div>
                </div>

                <button className="game-play-button" onClick={handlePlay}>
                    <Play size={22} />
                    Play Game
                </button>

                <p className="game-page-note">Opens in a new tab for the best performance.</p>
            </div>
        </div>
    );
}

export default NeonGravityRunner;
